import { css, html } from 'react-strict-dom';

import Text from '../../../components/Text';

type Props = {
  value: string;
  label: string;
};

/**
 * One figure in the summary card - a count or a total.  The rules between
 * stats stay outside the component.
 */
export default function ReportStat({ value, label }: Props) {
  return (
    <html.div style={styles.stat}>
      <Text typeface="headline" color="neutral100">
        {value}
      </Text>
      <Text typeface="body.small.regular" color="neutral60">
        {label}
      </Text>
    </html.div>
  );
}

const styles = css.create({
  stat: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingBlock: 16,
    paddingInline: 20,
    flexGrow: 1,
    minWidth: 0,
    '@media (max-width: 768px)': {
      paddingBlock: 14,
      paddingInline: 16,
    },
  },
});
